import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useApi from "../../hook/useApi";
import Loader from "../Loader/Loader";

const CMSViewLayer = ({ id }) => {
  const { AsyncGetApiCall } = useApi();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [cms, setCms] = useState(null);

  const fetchCMS = async () => {
    setLoading(true);
    const res = await AsyncGetApiCall(`/pages/view/${id}`);
    if (res?.errors) {
      toast.error(res.errors[0] || "Failed to fetch CMS");
      navigate("/cms-management");
    } else if (res?.success && res?.data) {
      setCms(res.data);
    } else {
      toast.error(res?.message || "Failed to fetch CMS");
      navigate("/cms-management");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (id) {
      fetchCMS();
    }
  }, [id]);

  return (
    <>
      {loading && <Loader />}
      <div className="card h-100 p-0 radius-12">
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex justify-content-between align-items-center">
          <h6 className="text-lg fw-semibold mb-0">View CMS</h6>
          <button
            type="button"
            className="btn btn-primary-600 btn-sm"
            onClick={() => navigate(`/cms-management/update/${id}`)}
          >
            Edit
          </button>
        </div>
        <div className="card-body p-24">
          <div className="mb-3">
            <h6 className="mb-1">Title</h6>
            <p className="mb-0">{cms?.title || "-"}</p>
          </div>
          <div className="mb-3">
            <h6 className="mb-1">Slug</h6>
            <p className="mb-0">{cms?.slug || "-"}</p>
          </div>
          <div>
            <h6 className="mb-1">Description</h6>
            <div
              className="border rounded p-3"
              dangerouslySetInnerHTML={{ __html: cms?.description || "-" }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CMSViewLayer;
